import { Component, OnInit, Inject, Input } from '@angular/core';

import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import { validate } from 'graphql';

export interface DialogContractorReviewResponseData {
  contractorName: string;
  review: string;
  reviewId: string;
  response:string;
}
@Component({
  selector: 'ebb-portal-dialog-contractorreviewresponse',
  templateUrl: './dialog-contractorreviewresponse.component.html'
})
export class DialogContractorReviewResponseComponent implements OnInit {
  @Input('review') name = this.data.review;
  public formContractorReviewResponse: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogContractorReviewResponseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContractorReviewResponseData,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.initializeNaming();
  }
  private initializeNaming(): void {
    this.formContractorReviewResponse.get('response').setValue(this.data.response);
  }
  private initializeForm(): void {
    this.formContractorReviewResponse = this.fb.group({
      response: ['', Validators.required]
    });
  }

  public onSave(): void {
    this.data.response = this.formContractorReviewResponse.get('response').value;
    this.dialogRef.close(this.data);
  }
  public onClickCancel(): void {
    this.dialogRef.close();
  }
}
